import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Edit2, Trash2, X, Check } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableLocations = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllLocations } = FetchData
    const { dataLocations, loadingFetchAllLocations } = fetchAllLocations

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificLocation,
        handleClickEnableDisableLocation,
        handleClickDeleteLocation
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } =
                    params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "location_name", headerName: "NOMBRE", minWidth: 300, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idlocation, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificLocation(idlocation)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteLocation(idlocation)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableLocation(idlocation, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableLocation(idlocation, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllLocations)&&(<LinearLoading />)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataLocations}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
